<template>
  <div class="container">

    <b-row class="ClientViewInfomationBox" position="fixed">
      <b-col cols="2" md="2" sm="2">
        <div class="ikona">
          <i class="fas fa-user" ></i>
        </div>
      </b-col>
      <b-col cols="10" md="10" sm="10">
        <b-row class="b-row-imie-nazw">
          <b-col>
            {{ user.name }} {{ user.surname }}
          </b-col>
        </b-row>
        <b-row class="kolumny">
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Email:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.email }}
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Telefon:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.cellphone }}
              </b-col>
            </b-row>
          </b-col>
    <!--     </b-row>
        <b-row class="kolumny"> -->
          <b-col cols="7"md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Adres:
              </b-col>
              <b-col style="margin-block-end:10px">
              {{user.street1}} {{user.building1}} <span v-if="user.flat1">/ {{user.flat1}}</span> <br> {{user.postal_code1}}, {{user.city1}}
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Pesel:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.pesel }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>



        <b-row>
          <b-col class="col-12 mb-3">

            <button v-if="allowInfo && nextLoanButton && !toContinue && !inProcessing" class=" form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click="nextLoan" :disabled="isRelogging">
              <b-spinner v-if="isRelogging" small class="mr-1"></b-spinner>
              {{ isRelogging ? 'Chwilę, trwa weryfikacja...' : 'Kolejna Pożyczka' }}
            </button>


<!--            <button class=" d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click=""  >Zmień numer telefonu</button> -->



            <button class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="doPassChange" >Zmień hasło</button>
            <button class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="doPhoneChange" >Zmień numer telefonu</button>


<!-- 
            <button v-if="repayLoanButton" class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="payLoan" >Spłać pożyczkę </button>


 -->
            

          </b-col>
        </b-row>




        <p v-if="allowInfo && !!parseInt(user.verified) && !nextLoanButton && !repayLoanButton && !parseInt(user.rejected_in_24)" class="col-10 mx-auto yellow-card"><strong>Aktualnie możliwość wnioskowania o pożyczkę jest nieaktywna. Systemetycznie sprawdzaj swoją Strefę klienta i możliwość złożenia wniosku. 
          </strong>
        </p>

        <p v-if="allowInfo && !!parseInt(user.verified) && !nextLoanButton && !repayLoanButton && !inProcessing && !!parseInt(user.rejected_in_24)" class="col-10 mx-auto yellow-card"><strong>Ostatni wniosek pożyczkowy został odrzucony i aktualnie nie masz możliwości złożenia nowego wniosku.
          </strong>
        </p>



        <p v-if="allowInfo && showProcessingInfo" class="col-10 mx-auto yellow-card"><strong>Twoja pożyczka została przekazana do wypłaty. Potwierdzenie wypłaty zostanie przesłane drogą email oraz sms. <br>
            W razie jakichkolwiek pytań zapraszamy do kontaktu z naszą infolinią.
          </strong>
        </p>




        <b-row v-if="allowInfo && !parseInt(user.verified)">
          <b-col class="col-12 mb-3 ">


            <p class="col-10 mx-auto yellow-card"><strong>Twoje konto nie zostało zweryfikowane, dokończ proces aby móc złożyć wniosek.
            </strong>
            </p>


            <div class="">

              <button class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="doVerify" >Wyślij SMS</button>
            </div>

          </b-col>
        </b-row>



      </b-col>


    </b-row>
    <b-row>
      <b-col colstyle="border-style:solid; border-width:thin; background-color:whitesmoke">

        <b-table  striped hover  :items="getLoansData" :fields="fields"  ref='loans_table' @refreshed="newdata" @row-clicked="clicked" >

          <template #cell(show_details)="row">


            <b-button v-if="parseFloat(row.item.to_be_continied)==0" size="sm" @click="row.toggleDetails(); getDocs(row.item.id);" class="mr-2" style="width:40px; background-color:#bababa; margin:0;">


              <i v-if="row.detailsShowing" class="fa fa-minus" />
              <i v-else class="fa fa-plus" />

              <!--
              {{ row.detailsShowing ? 'Pokaż' : 'Ukryj'}} <br> Szczegóły  -->
            </b-button>





            <b-button v-if="row.item.to_continue" size="sm" @click="goContinue(row.item.uniqueid, row.item.id, row.item.was_final_step, row.item);" class="mr-2" style=" background-color:#bababa; margin:0;">

              <i  class="fa fa-edit" /> Dokończ wniosek
                    
            </b-button>


          </template>

          <template #cell(to_be_paid)="row">
            <span v-if="parseFloat(row.item.status_id) == 3.2">cesja</span>
            <span v-else-if="!!parseInt(row.item.is_closed) && parseFloat(row.item.status_id) >= 3">spłacono</span>
            <span v-else>{{ row.item.to_be_paid }} zł</span>
          </template>

          <template #row-details="row">
            <b-card>

              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Status:</b></b-col>
                <b-col>{{ !!parseInt(row.item.is_closed) ? 'Zamknięty' : parseFloat(row.item.status_id) == 1.05 ? 'Wniosek' : 'Aktywny' }}</b-col>
              </b-row>


              <div v-if="!parseInt(row.item.is_closed)">

                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Produkt:</b></b-col>
                  <b-col>{{ row.item.template_name }}</b-col>
                </b-row>
                

                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Termin spłaty pożyczki:</b></b-col>
                  <b-col>{{ !!row.item.incoming_payment && row.item.incoming_payment.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1') }}</b-col>
                </b-row>

                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>RRSO</b></b-col>
                  <b-col><span  >{{ parseFloat(row.item.RRSO).toFixed(2) }} %</span></b-col>
                </b-row>

                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Prowizja</b></b-col>
                  <b-col><span  >{{ parseFloat(row.item.initial_cost).toFixed(2) }} zł</span></b-col>
                </b-row>

                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Obsługa</b></b-col>
                  <b-col><span  >{{ parseFloat(row.item.service_fee).toFixed(2) }} zł</span></b-col>
                </b-row>


                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Odsetki</b></b-col>
                  <b-col><span  > {{ ( row.item.interest_calc < 0 ? 0 : parseFloat(row.item.interest_calc) ).toFixed(2) }} zł</span></b-col>
                </b-row>


                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Odsetki za opóźnienie</b></b-col>
                  <b-col><span  >{{ parseFloat(row.item.due_additional_cost).toFixed(2) }} zł</span></b-col>
                </b-row>


                <b-row class="mb-4"  v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Odbiorca przelewu</b></b-col>
                  <b-col><span  @click="copyToClipboard">Fingo Capital<i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>


                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Nr. rachunku do przelewu:</b></b-col>
                  <b-col><span @click="copyToClipboard"> {{ row.item.loan_bank_account }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Tytuł przelewu:</b></b-col>
                  <b-col><span @click="copyToClipboard">spłata do umowy nr. {{ row.item.contract_nbr }} PESEL {{ user.pesel }}<i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Kwota do spłaty teraz:</b></b-col>
                  <b-col><span @click="copyToClipboard">{{ row.item.to_be_paid_now }} zł<i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4" v-if="parseInt(row.item.status_id) >= 3">
                  <b-col sm="3" class="text-sm-right"><b>Pozostała całkowita kwota do spłaty:</b></b-col>
                  <b-col><span @click="copyToClipboard">{{ row.item.to_be_paid }} zł<i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

              </div>




              <div class="d-flex flex-column">
                <p class="HeaderDoPobrania">Do pobrania :</p>
                  <b-link class="HrefDownload" v-for="item in docData" :key="item.id" @click="download(item.id, item.document_name)">
                    <i class="fas fa-download"></i> {{ item.document_name }}
                  </b-link>
              </div>





<!--               <div v-if="parseFloat(row.item.status_id) == 1.05 && showSignature">

                  <h4 class="dark entry-title"> <i class="fas fa-file-signature"></i> Po podpisaniu umowy ostatecznie zweryfikujemy Twój wniosek. </h4>

              
                  <SignContract v-if="showSignature" :loan_id="row.item.id" label="Podpisz Umowę" @consent="consentChange" @signed="signedTerms"/>

              </div>


              <h4 class="dark entry-title" style="color:lemon;"  v-if="showThanks"> <i class="fas fa-check"></i> Dziękujemy za Podpisanie umowy, poinformujemy Cię o wypłacie pożyczki. </h4>

 -->


              <h4 class="dark entry-title" style="color:red;" v-if="!!err"> <i class="fas fa-error"></i> {{ err }} </h4>

            </b-card>
          </template>



        </b-table>

      </b-col>
    </b-row>



    <PassChange />
    <PhoneChange />


    </div>
</template>

<script>


/*
  //import ZCVB from "./components/ZetosClientViewButtons";
  import __CFG from '@/conf/config.json';


  import axios from 'axios';
  // set to allow session cookies
  axios.defaults.withCredentials = true;
*/


  import PassChange from '@/components/PassChange.vue';
  import PhoneChange from '@/components/PhoneChange.vue';
  import SignContract from '@/components/SignContract';

  export default {

    components: {
      SignContract,
      PassChange,
      PhoneChange
    },

    data() {
      return {

        err: '',

        authCode: '',
        loanId: null,

        isSigned: false,
        showThanks: false,
        showSignature: true,

        goAnotherLoan: false,
        isRelogging: false,


        allowInfo: false,

        showProcessingInfo: false,

        toContinue: false,

        allowContinue: true,

        inProcessing: false,

        nextLoanButton: false,

        blockDays: 0,
        repayLoanButton: false,

        user: {},


        fields: [


          {
            key: 'show_details', label: '', tdClass: 'd-flex justify-content-left align-middle', thStyle: 'width: 80px;'
          },


          {
            key: 'contract_nbr_status', label: 'Numer Umowy / Status', tdClass: 'align-middle'
          },

          {
            key: 'loan_date', label: 'Data Pożyczki', tdClass: 'align-middle'
          },

          {
            key: 'to_be_paid', label: 'Saldo do spłaty', tdClass: 'align-middle'
          }


        ],


        items: [
/*          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "0" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },*/
        ],





        loansData: [],

        docs: []


      };
    },


    computed: {


      docData(){


        let seen = [];



        return !this.docs ? [] : this.docs.filter( doc => { 


          //console.log(seen);


          return String(doc.markers).indexOf('agreement') > -1 && seen.indexOf(doc.document_name.trim()) == -1 && doc.document_name.indexOf('WZOR') == -1 && seen.push(doc.document_name.trim());


        } ) ;
      },



      cptItems() {
        return this.items.map((item) => {
          let tmp = item;
          item.do_spłaty > 0 ? item._rowVariant = "" : item._rowVariant = 'success';
          return tmp;
        })
      }



    },
    methods: {

      payLoan(){
          this.get('/bm').then(response=>{


            console.log(response.data.Message);


              location.href = response.data.Message;

          }).catch(error =>{

            console.log(error);

            this.toast('pożyczka nie aktywna')
          })
      },

      
      clicked(row){

        row._showDetails = !row._showDetails;
      },


      newdata(){

///console.log('rows loaded')

//console.log(this.$refs)

      },


      signDone(){

          this.isSigned = true;
          this.showThanks = true;
      },

      signedTerms(code, loan_id){


            this.authCode = code;
            this.loanId = loan_id;

            this.signTerms();

            
            this.showSignature = false;

      },


      signTerms() {

          var me = this;

          this.put( '/accept', {
            loan_id: this.loanId,
            activation_code: this.authCode
          })
              .then(response => {


                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);


                  ok && me.signDone();


                  console.log('acccepted  ')

                }
              })
              .catch(error => {


                me.showSignature = true;

                           // Error
                  if (error.response) {

                    console.log(error.response);


                    this.err = error.response.data.Message || (typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors);

                  }
              });

        },

      consentChange(type, grant){

        let cons = ['first', 2, 'second', 1];


        if (cons.indexOf(type) > -1) {


              this.patch( '/client/consent', {
                consent_id: cons[ cons.indexOf(type) + 1 ],
                consent_bit: grant | 0
              })
                  
                  .then(response => {


                    if (!!response.data) {

                      let ok = !(response.data.IS_ERROR | 0);
                      
                      console.log('consent done  ')
                    }
                  })
                  .catch(error => {

                      // Error
                      if (error.response) {

                        console.log(error.response);

                        //this.err = error.response.data.Message || (typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors);

                      }
                  });

        }




      },


      doPassChange(){

        this.echo('pass_change_dialog');
      },


      doPhoneChange(){

        this.echo('phone_change_dialog');
      },


      doVerify(){



        this.log( 'go verify code - logged user ' );


        this.$router.push({path: '/verifycode', query: { do: 'verify'}});

      },
      

      nextLoan() {

        if (this.isRelogging) return;

        this.isRelogging = true;
        this.goAnotherLoan = true;

        this.echo('login_reload');

      },



      download(downloadID, name) {


/*
          this.get('/client/document/' + downloadID, {

            responseType: 'blob'
          })
          .then((response) => {


            var fileURL = window.URL.createObjectURL(new Blob( [response.data] ));
*/

            let fileLink = document.createElement('a');

            fileLink.href = '/api/client/document/' + downloadID; // fileURL;
            fileLink.setAttribute('download', String(name).trim() + '.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();



        //  });
      },

      getDocs(loanId){

          this.get('/client/documents/' + loanId)


            .then(response => {


              this.docs = response.data;

            //  console.log(this.docData)


            })
            .catch(error => {
              console.log('Network error', error);
            });
      },

      
      goContinue(uid, loanId, wasFinalStep, rowData) {


        var page = this.$root.mainpage,
            dat,
            step;


            page.isLoading = true;

            this.get('/application/resume/' + uid)

            .then(response => {




              dat = Array.isArray(response.data) && response.data.length > 0 ? {...response.data[0]} : response.data;

              step = dat.hasOwnProperty('step') ? dat.step : '';




              //console.log(response);


              switch (step) {

                case 'wait':
                  break;

                case 'counteroffer':
                  page.isLoading =false;
                  this.$router.push({path: 'proposal'});
                  return;

                case 'transactionlink':

                  if (parseInt(wasFinalStep) === 1) {

                    // transactionlink workflow token
                    this.get( '/transactionlink/' +  window.__sid )
                    .then(response => {

                      if (!!response.data) {

                        page.isLoading = false;
                        page.party_id = window.__sid;
                        page.workflow_token = response.data;
                        page.loanId = loanId;
                        this.$router.push({path: 't10l'});
                      }
                    })
                    .catch(error => {

                      console.log('workflow token error', error);
                    });

                  } else {

                    // was_final_step != 1 so resume from fullform
                    page.isLoading = false;

                    //page.isRegisterLink = 2;

                    this.$set(page.form, 'loan_id', rowData.ireq_id);
                    this.$set(page.form, 'parent_id', rowData.parent_id || rowData.ireq_id);
                    page.form.is_lead = 9;
                    this.$set(page.form, 'comments', '__edit;__final');
                    this.$router.push({path: '/fullform'});
                  }

                  return;

                case 'reject':
                    page.isLoading=false;
                    this.$router.push({path: 'rej'});
                    return;


                case 'accept':
                    page.isLoading=false;
                    page.loanId = loanId;
                    this.$router.push({path: 'thankyou'});
                    return;

                                                                  
                default:
                  if (parseInt(wasFinalStep) === 1) {

                    // was_final_step=1 so go to transactionlink
                    this.get( '/transactionlink/' +  window.__sid )
                    .then(response => {

                      if (!!response.data) {

                        page.isLoading = false;
                        page.party_id = window.__sid;
                        page.workflow_token = response.data;
                        page.loanId = loanId;
                        this.$router.push({path: 't10l'});
                      }
                    })
                    .catch(error => {

                      console.log('workflow token error', error);
                    });

                  } else {

                    // resume from fullform step
                    page.isLoading = false;
                    //page.isRegisterLink = 2;
                    
                    this.$set(page.form, 'loan_id', rowData.ireq_id);
                    this.$set(page.form, 'parent_id', rowData.parent_id || rowData.ireq_id);
                    page.form.is_lead = 9;
                    this.$set(page.form, 'comments', '__edit;__final');
                    this.$router.push({path: '/fullform'});
                  }
                  return;
              }


            })
            .catch(error => {
              console.log('Network error', error);
            });

      },


      getLoansData (ctx, callback) {


        // load clients contracts
        this.get('/client/loans')

          .then(response => {

            let items = [], first = true;

            if (!response.data) {

              items = [];
            }
            else {

              // lets see if we have some loans under processing
              response.data.map( l => {



                [1.09, 1.1, 1.15].indexOf(parseFloat(l.status_id)) > -1 
                  && (this.showProcessingInfo = true);



                // activate repay button if loan found active loan
                !this.repayLoanButton && parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4 && !parseInt(l.is_closed) 
                  && (this.repayLoanButton = true);

                // application analysis and processing ongoing
                !this.inProcessing && parseInt(l.status_id) != 2 && parseFloat(l.status_id) >= 1 && parseFloat(l.status_id) < 3 
                  && (this.inProcessing = true); 


                // found application to continue
                !this.toContinue && parseFloat(l.to_be_continied) > 0 && parseFloat(l.status_id) < 1 
                  && (this.toContinue = true) 
                  && (l.to_continue = true);

              });


              items = response.data.filter( l => (parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4) 

                // docs ready
                || parseFloat(l.status_id) == 1.05 

                // early repaiment
                || parseFloat(l.status_id) == 5

                // renouncement
                || parseFloat(l.status_id) == 6

                // reversed renouncement
                || parseFloat(l.status_id) == 6.05

                || parseFloat(l.to_be_continied)==1 ).map( l => {

                if (first && parseFloat(l.to_be_continied)==0 && !this.toContinue) {

                  l._showDetails = first;

                  this.getDocs(l.id);

                  first = false;
                }








                l.loan_date = l.loan_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

                l.pay_out_ammount = parseInt(l.pay_out_ammount);

                l.contract_nbr_status = String(l.contract_nbr) + (!!parseInt(l.is_closed) && parseInt(l.status_id) > 3 ? ' / zamknięty' : parseFloat(l.status_id) == 1.05 ? ' / wniosek' : ' / ' + l.status_name);       


                l.interest_calc =  parseFloat(l.to_be_paid) - (parseFloat(l.pay_out_ammount) + parseFloat(l.service_fee) + parseFloat(l.initial_cost));





                return l;
              })
            }

  //console.log(items);



            // no active loans and no rejections so activate next loan button
            this.nextLoanButton = this.canApplyForLoan(this.user);


            // finally show user info
            this.allowInfo = true;



            callback(items);

          })
          .catch(error => {
            callback([]);
          });


          // Must return null or undefined to signal b-table that callback is being used
          return null
      }




    },


    created() {



      this.user = JSON.parse(localStorage.getItem('user'));

      this.blockDays = parseInt(this.user.block_days_left) || 0;

      // in case of no active loans and no blocking status so activate next loan button
      this.nextLoanButton = this.canApplyForLoan(this.user);



      this._onLoginReloaded = () => {

        this.user = JSON.parse(localStorage.getItem('user'));
        this.isRelogging = false;

        if (this.goAnotherLoan) {

          this.goAnotherLoan = false;

          if (this.canApplyForLoan(this.user)) {

            // reset registerlink flag
            this.$root.mainpage.isRegisterLink = false;

            this.$router.push({path: '/fullform'});
          }
          else {

            this.blockDays = parseInt(this.user.block_days_left);
            this.nextLoanButton = false;
          }
        }
      };

      this._onLoginReloadError = () => {

        this.goAnotherLoan = false;
        this.isRelogging = false;
        this.toast('Błąd odświeżania sesji. Spróbuj ponownie.');
      };

      this.listen('login_reloaded', this._onLoginReloaded);
      this.listen('login_reload_error', this._onLoginReloadError);







/*
      // load clients contracts
      this.get('/client/loans')

        .then(response => {

          //let row = ['contract_nbr', '']


          if (!response.data) {

            this.loansData =  [];
          }
          else {

            this.loansData = response.data;

            this.items = this.loansData.filter( l => (parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4) || parseFloat(l.status_id) == 1.05 ).map( l => {


              l.loan_date = l.loan_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

              l.pay_out_ammount = parseInt(l.pay_out_ammount);


              l.contract_nbr += !!parseInt(l.is_closed) && parseInt(l.status_id) > 3 ? ' - spłacona' : parseFloat(l.status_id) == 1.05 ? ' - wniosek' : '';

              // some mods to data

              return l;
            });

          }



        })
        .catch(error => {
          console.log('Network error', error);
        });

*/



    },

    beforeDestroy() {

      this.unlisten('login_reloaded', this._onLoginReloaded);
      this.unlisten('login_reload_error', this._onLoginReloadError);
    },

    mounted() {





    }
  }
</script>


<style scoped>

  .HeaderDoPobrania{
    margin-block-end:20px;
    font-weight:bold;
  }
  .fa-user {
    font-size: 80px;
    border-radius: 100px;
    box-shadow: 0px 0px 5px #585858;
    padding: 0.5em 0.6em;
  }


  .ikona {

    margin-top:35px;
    justify-content: center;
    text-align: center;
  }


  .NauClientViewTitle {
    color: #333;
  }




  .btn {
    text-decoration-style: solid;
    font-size: 17px;
    width: 230px;

  }
  .HrefDownload{
    margin-block-end:20px;
    color: orange;
  }

  .HrefDownload:hover{
    margin-block-end:20px;
    color: tomato;
  }

  @media (max-width: 575px) {
    .NauClientViewTitle {
      font-size: 15px
    }
    .ikona {
      justify-content: right;
      text-align: right;
      margin-top:1px;
    }
    .fa-user {
      opacity:0;
    }
    .btn {
      color: #f79949;
      text-decoration-style: solid;
      background-color: transparent;
      font-size: 17px;
      width: 230px;
      margin-block-end: 16px;

    }
  }
  @media (max-width: 991px) {
    .NauClientViewTitle {
      font-size: 15px

    }
    .fa-user {
      font-size: 26px;
    }
    .ikona {
      justify-content: right;
      text-align: right;
      margin-top: 10px;
    }
  }
  .b-row-imie-nazw{
    margin-top:.3em;
    font-size: 2.4rem;
    text-decoration-style:solid;
    margin-block-end: 8px;
    text-align:left;
  }
  .kolumny {
    width: 100%;
  }
 .b-col{
   display:flex;
 }


 .copy-icon {

    color: #045439;
    padding-left:1rem;
 }


</style>



// WEBPACK FOOTER //
// src/FingoClientView.vue